
import * as React from 'react';
import { fluentSvgIconStyles } from '../../../../styles/iconStyles';

export const ArrowCircleUpLeft20Regular: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return <svg role="img" focusable="false" aria-hidden viewBox="0 0 20 20" width={20} height={20} fill="currentColor" className={props.className} style={{ ...props.style, ...fluentSvgIconStyles }} onClick={props.onClick}>
        <path
            d="M7.15 7.14A.5.5 0 0 1 7.5 7h5a.5.5 0 0 1 0 1H8.7l4.15 4.15a.5.5 0 0 1-.7.7L8 8.71v3.79a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 .14-.35ZM10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-7 8a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z"
            fill="currentColor"
        />
    </svg>
}